import React, { useEffect, useState } from "react";
import Table, { AvatarCell, NumberCell } from "./table/Table";
import SchedularStatistics from "./SchedularStatistics";
import { useNavigate } from "react-router-dom";
import Basic from "./reactScheduler/Basic";
import {getAuthorization} from "../../../axios/AxiosAut";
import { useDispatch, useSelector } from "react-redux";

export default function SchedulerDashboard() {
  const Navigate = useNavigate();
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addschedule = Permissions.find((o) => o.codename === "add_jobschedule");
  const [Data, setData] = useState([])
  useEffect(() => {
    getAuthorization()
    .get("company/get_company_schedules/")
    .then((res) => {
      setData(res.data)
      console.log("res.data", res.data)
    })
    .catch((err) => {
      console.log("Error in getting schedule", err);
    });
  }, [])
  
  const columns = React.useMemo(
    () => [
      {
        Cell: NumberCell,
        accessor: "name",
      },
      {
        accessor: "assigned_to",
        Cell: AvatarCell,
      },
      {
        accessor: "timeline",
        Cell: ({row}) => (
          <div
            className="flex flex-row space-x-2
           px-3 py-1 uppercase leading-wide rounded-full shadow-sm bg-cyan-100 text-blue-200 text-sm font-medium"
          >
            <div>
              <svg
                width="15"
                height="18"
                viewBox="0 0 20 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5259 7.69318H0.47408C0.212388 7.69318 0 7.48079 0 7.2191V4.72117C0 3.44898 1.03492 2.41406 2.30711 2.41406H17.6929C18.9648 2.41406 19.9998 3.44898 19.9998 4.72117V7.21934C20 7.48103 19.7876 7.69318 19.5259 7.69318ZM0.948159 6.74502H19.0518V4.72093C19.0518 3.97165 18.4424 3.36199 17.6931 3.36199H2.30711C1.55759 3.36199 0.948159 3.97165 0.948159 4.72093V6.74502Z"
                  fill="#1F78B4"
                />
                <path
                  d="M9.55674 22.1988H2.30711C1.03492 22.1988 0 21.1639 0 19.8917V7.21627C0 6.95458 0.212388 6.74219 0.47408 6.74219H19.5259C19.7876 6.74219 20 6.95458 20 7.21627V11.7556C20 12.0173 19.7876 12.2297 19.5259 12.2297C19.2642 12.2297 19.0518 12.0173 19.0518 11.7556V7.69035H0.948159V19.8915C0.948159 20.6408 1.55783 21.2504 2.30711 21.2504H9.55674C9.81843 21.2504 10.0308 21.4628 10.0308 21.7245C10.0308 21.9862 9.81867 22.1988 9.55674 22.1988Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.27877 4.90753C4.01708 4.90753 3.80469 4.69514 3.80469 4.43345V1.34127C3.80469 1.07958 4.01708 0.867188 4.27877 0.867188C4.54046 0.867188 4.75285 1.07958 4.75285 1.34127V4.43345C4.75285 4.69514 4.5407 4.90753 4.27877 4.90753Z"
                  fill="#1F78B4"
                />
                <path
                  d="M15.7241 4.90753C15.4624 4.90753 15.25 4.69514 15.25 4.43345V1.34127C15.25 1.07958 15.4624 0.867188 15.7241 0.867188C15.9858 0.867188 16.1982 1.07958 16.1982 1.34127V4.43345C16.1982 4.69514 15.9858 4.90753 15.7241 4.90753Z"
                  fill="#1F78B4"
                />
                <path
                  d="M9.99752 4.90753C9.73583 4.90753 9.52344 4.69514 9.52344 4.43345V1.34127C9.52344 1.07958 9.73583 0.867188 9.99752 0.867188C10.2592 0.867188 10.4716 1.07958 10.4716 1.34127V4.43345C10.4716 4.69514 10.2592 4.90753 9.99752 4.90753Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.26361 10.8195H3.90354C3.74117 10.8195 3.60938 10.6879 3.60938 10.5253V10.1653C3.60938 10.0029 3.74093 9.87109 3.90354 9.87109H4.26361C4.42598 9.87109 4.55777 10.0027 4.55777 10.1653V10.5253C4.55777 10.6879 4.42621 10.8195 4.26361 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M8.20892 10.8195H7.84885C7.68648 10.8195 7.55469 10.6879 7.55469 10.5253V10.1653C7.55469 10.0029 7.68624 9.87109 7.84885 9.87109H8.20892C8.37129 9.87109 8.50309 10.0027 8.50309 10.1653V10.5253C8.50309 10.6879 8.37153 10.8195 8.20892 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M12.1542 10.8195H11.7942C11.6318 10.8195 11.5 10.6879 11.5 10.5253V10.1653C11.5 10.0029 11.6316 9.87109 11.7942 9.87109H12.1542C12.3166 9.87109 12.4484 10.0027 12.4484 10.1653V10.5253C12.4484 10.6879 12.3168 10.8195 12.1542 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M16.0917 10.8195H15.7317C15.5693 10.8195 15.4375 10.6879 15.4375 10.5253V10.1653C15.4375 10.0029 15.5691 9.87109 15.7317 9.87109H16.0917C16.2541 9.87109 16.3859 10.0027 16.3859 10.1653V10.5253C16.3857 10.6879 16.2541 10.8195 16.0917 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.26361 14.7609H3.90354C3.74117 14.7609 3.60938 14.6293 3.60938 14.4667V14.1067C3.60938 13.9443 3.74093 13.8125 3.90354 13.8125H4.26361C4.42598 13.8125 4.55777 13.9441 4.55777 14.1067V14.4667C4.55777 14.6293 4.42621 14.7609 4.26361 14.7609Z"
                  fill="#1F78B4"
                />
                <path
                  d="M8.20892 14.7609H7.84885C7.68648 14.7609 7.55469 14.6293 7.55469 14.4667V14.1067C7.55469 13.9443 7.68624 13.8125 7.84885 13.8125H8.20892C8.37129 13.8125 8.50309 13.9441 8.50309 14.1067V14.4667C8.50309 14.6293 8.37153 14.7609 8.20892 14.7609Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.26361 18.7062H3.90354C3.74117 18.7062 3.60938 18.5747 3.60938 18.412V18.052C3.60938 17.8896 3.74093 17.7578 3.90354 17.7578H4.26361C4.42598 17.7578 4.55777 17.8894 4.55777 18.052V18.412C4.55777 18.5747 4.42621 18.7062 4.26361 18.7062Z"
                  fill="#1F78B4"
                />
                <path
                  d="M8.20892 18.7062H7.84885C7.68648 18.7062 7.55469 18.5747 7.55469 18.412V18.052C7.55469 17.8896 7.68624 17.7578 7.84885 17.7578H8.20892C8.37129 17.7578 8.50309 17.8894 8.50309 18.052V18.412C8.50309 18.5747 8.37153 18.7062 8.20892 18.7062Z"
                  fill="#1F78B4"
                />
                <path
                  d="M15.16 22.203C12.4914 22.203 10.3203 20.0319 10.3203 17.3633C10.3203 14.6945 12.4914 12.5234 15.16 12.5234C17.8286 12.5234 19.9996 14.6945 19.9996 17.3633C19.9996 20.0319 17.8283 22.203 15.16 22.203ZM15.16 13.4716C13.014 13.4716 11.2685 15.2174 11.2685 17.3633C11.2685 19.5092 13.014 21.2548 15.16 21.2548C17.3059 21.2548 19.0514 19.5092 19.0514 17.3633C19.0514 15.2174 17.3056 13.4716 15.16 13.4716Z"
                  fill="#1F78B4"
                />
                <path
                  d="M14.6677 19.1306C14.6639 19.1306 14.6601 19.1306 14.6563 19.1303C14.5228 19.1272 14.3967 19.0677 14.3093 18.967L13.3033 17.8065C13.1319 17.6088 13.1532 17.3091 13.3511 17.1378C13.5488 16.9666 13.8487 16.9872 14.0198 17.1856L14.6845 17.9525L16.569 15.9789C16.7496 15.789 17.0499 15.7826 17.2391 15.9635C17.4285 16.1443 17.4353 16.4442 17.2545 16.6336L15.0102 18.9841C14.9208 19.0777 14.7971 19.1306 14.6677 19.1306Z"
                  fill="#1F78B4"
                />
              </svg>
            </div>
            <div className="ml-2">{row.original.start_date}</div>
            <div>
              <svg
                width="17"
                height="17"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13437 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                  fill="#1F78B4"
                />
              </svg>
            </div>
            <div className="ml-2">{row.original.start_time}</div>
            <div>
              <svg
                width="15"
                height="18"
                viewBox="0 0 20 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5259 7.69318H0.47408C0.212388 7.69318 0 7.48079 0 7.2191V4.72117C0 3.44898 1.03492 2.41406 2.30711 2.41406H17.6929C18.9648 2.41406 19.9998 3.44898 19.9998 4.72117V7.21934C20 7.48103 19.7876 7.69318 19.5259 7.69318ZM0.948159 6.74502H19.0518V4.72093C19.0518 3.97165 18.4424 3.36199 17.6931 3.36199H2.30711C1.55759 3.36199 0.948159 3.97165 0.948159 4.72093V6.74502Z"
                  fill="#1F78B4"
                />
                <path
                  d="M9.55674 22.1988H2.30711C1.03492 22.1988 0 21.1639 0 19.8917V7.21627C0 6.95458 0.212388 6.74219 0.47408 6.74219H19.5259C19.7876 6.74219 20 6.95458 20 7.21627V11.7556C20 12.0173 19.7876 12.2297 19.5259 12.2297C19.2642 12.2297 19.0518 12.0173 19.0518 11.7556V7.69035H0.948159V19.8915C0.948159 20.6408 1.55783 21.2504 2.30711 21.2504H9.55674C9.81843 21.2504 10.0308 21.4628 10.0308 21.7245C10.0308 21.9862 9.81867 22.1988 9.55674 22.1988Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.27877 4.90753C4.01708 4.90753 3.80469 4.69514 3.80469 4.43345V1.34127C3.80469 1.07958 4.01708 0.867188 4.27877 0.867188C4.54046 0.867188 4.75285 1.07958 4.75285 1.34127V4.43345C4.75285 4.69514 4.5407 4.90753 4.27877 4.90753Z"
                  fill="#1F78B4"
                />
                <path
                  d="M15.7241 4.90753C15.4624 4.90753 15.25 4.69514 15.25 4.43345V1.34127C15.25 1.07958 15.4624 0.867188 15.7241 0.867188C15.9858 0.867188 16.1982 1.07958 16.1982 1.34127V4.43345C16.1982 4.69514 15.9858 4.90753 15.7241 4.90753Z"
                  fill="#1F78B4"
                />
                <path
                  d="M9.99752 4.90753C9.73583 4.90753 9.52344 4.69514 9.52344 4.43345V1.34127C9.52344 1.07958 9.73583 0.867188 9.99752 0.867188C10.2592 0.867188 10.4716 1.07958 10.4716 1.34127V4.43345C10.4716 4.69514 10.2592 4.90753 9.99752 4.90753Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.26361 10.8195H3.90354C3.74117 10.8195 3.60938 10.6879 3.60938 10.5253V10.1653C3.60938 10.0029 3.74093 9.87109 3.90354 9.87109H4.26361C4.42598 9.87109 4.55777 10.0027 4.55777 10.1653V10.5253C4.55777 10.6879 4.42621 10.8195 4.26361 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M8.20892 10.8195H7.84885C7.68648 10.8195 7.55469 10.6879 7.55469 10.5253V10.1653C7.55469 10.0029 7.68624 9.87109 7.84885 9.87109H8.20892C8.37129 9.87109 8.50309 10.0027 8.50309 10.1653V10.5253C8.50309 10.6879 8.37153 10.8195 8.20892 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M12.1542 10.8195H11.7942C11.6318 10.8195 11.5 10.6879 11.5 10.5253V10.1653C11.5 10.0029 11.6316 9.87109 11.7942 9.87109H12.1542C12.3166 9.87109 12.4484 10.0027 12.4484 10.1653V10.5253C12.4484 10.6879 12.3168 10.8195 12.1542 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M16.0917 10.8195H15.7317C15.5693 10.8195 15.4375 10.6879 15.4375 10.5253V10.1653C15.4375 10.0029 15.5691 9.87109 15.7317 9.87109H16.0917C16.2541 9.87109 16.3859 10.0027 16.3859 10.1653V10.5253C16.3857 10.6879 16.2541 10.8195 16.0917 10.8195Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.26361 14.7609H3.90354C3.74117 14.7609 3.60938 14.6293 3.60938 14.4667V14.1067C3.60938 13.9443 3.74093 13.8125 3.90354 13.8125H4.26361C4.42598 13.8125 4.55777 13.9441 4.55777 14.1067V14.4667C4.55777 14.6293 4.42621 14.7609 4.26361 14.7609Z"
                  fill="#1F78B4"
                />
                <path
                  d="M8.20892 14.7609H7.84885C7.68648 14.7609 7.55469 14.6293 7.55469 14.4667V14.1067C7.55469 13.9443 7.68624 13.8125 7.84885 13.8125H8.20892C8.37129 13.8125 8.50309 13.9441 8.50309 14.1067V14.4667C8.50309 14.6293 8.37153 14.7609 8.20892 14.7609Z"
                  fill="#1F78B4"
                />
                <path
                  d="M4.26361 18.7062H3.90354C3.74117 18.7062 3.60938 18.5747 3.60938 18.412V18.052C3.60938 17.8896 3.74093 17.7578 3.90354 17.7578H4.26361C4.42598 17.7578 4.55777 17.8894 4.55777 18.052V18.412C4.55777 18.5747 4.42621 18.7062 4.26361 18.7062Z"
                  fill="#1F78B4"
                />
                <path
                  d="M8.20892 18.7062H7.84885C7.68648 18.7062 7.55469 18.5747 7.55469 18.412V18.052C7.55469 17.8896 7.68624 17.7578 7.84885 17.7578H8.20892C8.37129 17.7578 8.50309 17.8894 8.50309 18.052V18.412C8.50309 18.5747 8.37153 18.7062 8.20892 18.7062Z"
                  fill="#1F78B4"
                />
                <path
                  d="M15.16 22.203C12.4914 22.203 10.3203 20.0319 10.3203 17.3633C10.3203 14.6945 12.4914 12.5234 15.16 12.5234C17.8286 12.5234 19.9996 14.6945 19.9996 17.3633C19.9996 20.0319 17.8283 22.203 15.16 22.203ZM15.16 13.4716C13.014 13.4716 11.2685 15.2174 11.2685 17.3633C11.2685 19.5092 13.014 21.2548 15.16 21.2548C17.3059 21.2548 19.0514 19.5092 19.0514 17.3633C19.0514 15.2174 17.3056 13.4716 15.16 13.4716Z"
                  fill="#1F78B4"
                />
                <path
                  d="M14.6677 19.1306C14.6639 19.1306 14.6601 19.1306 14.6563 19.1303C14.5228 19.1272 14.3967 19.0677 14.3093 18.967L13.3033 17.8065C13.1319 17.6088 13.1532 17.3091 13.3511 17.1378C13.5488 16.9666 13.8487 16.9872 14.0198 17.1856L14.6845 17.9525L16.569 15.9789C16.7496 15.789 17.0499 15.7826 17.2391 15.9635C17.4285 16.1443 17.4353 16.4442 17.2545 16.6336L15.0102 18.9841C14.9208 19.0777 14.7971 19.1306 14.6677 19.1306Z"
                  fill="#1F78B4"
                />
              </svg>
            </div>
            <div className="ml-2">{row.original.end_date}</div>
            <div>
              <svg
                width="17"
                height="17"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13437 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                  fill="#1F78B4"
                />
              </svg>
            </div>
            <div className="ml-2">{row.original.end_time}</div>
          </div>
        ),
      },
      {
        accessor: "action",
        Cell: (value) => (
          <button onClick={()=>Navigate("/dashboard/management/schedule-order/group-user", {
            state: value.row.original
          })}>
            <svg
              width="34"
              height="34"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0356 26.7547L11.0355 26.7547C11.0345 26.7558 11.0335 26.7568 11.0325 26.7578C11.0225 26.7678 11.0126 26.7777 11.0027 26.7875C10.8402 26.9497 10.6964 27.0932 10.5951 27.2722C10.4937 27.4512 10.4446 27.6484 10.3892 27.8711C10.3855 27.886 10.3817 27.901 10.378 27.9162L8.8811 33.9036L8.87442 33.9303C8.83518 34.087 8.79327 34.2543 8.77952 34.3949C8.76439 34.5496 8.76791 34.8107 8.97733 35.0201C9.18673 35.2295 9.44779 35.233 9.60252 35.2179C9.74305 35.2041 9.91037 35.1622 10.067 35.123L10.0938 35.1163L16.0812 33.6194C16.0964 33.6157 16.1114 33.6119 16.1262 33.6082C16.349 33.5528 16.5462 33.5037 16.7252 33.4023C16.9042 33.301 17.0477 33.1571 17.2099 32.9947C17.2207 32.9838 17.2316 32.9729 17.2427 32.9618L31.9367 18.2678L31.96 18.2445C32.2735 17.9311 32.5435 17.6611 32.7307 17.4157C32.9313 17.1528 33.0832 16.8604 33.0832 16.5C33.0832 16.1396 32.9313 15.8472 32.7307 15.5843C32.5435 15.3389 32.2734 15.0689 31.96 14.7555L31.9367 14.7322L29.2652 12.0607L29.2419 12.0374C28.9285 11.724 28.6585 11.4539 28.4131 11.2667C28.1502 11.0661 27.8578 10.9142 27.4974 10.9142C27.137 10.9142 26.8446 11.0661 26.5817 11.2667C26.3363 11.4539 26.0663 11.7239 25.7529 12.0374L25.7296 12.0607L11.0356 26.7547Z"
                stroke="#1F78B4"
              />
              <path
                d="M23 13.7526L28.5 10.0859L34 15.5859L30.3333 21.0859L23 13.7526Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
        ),
      },
    ],
    []
  );
  return (
    <>
      <div className="ml-8 container w-auto mb-7">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <div>
              <h2 className="font-Montserrat text-xl font-bold text-black">
                Schedule Dashboard
              </h2>
              <div className="border-b-2 border-blue-200 w-20"></div>
            </div>
          </div>
          <div>
          {!addschedule ===undefined ||  addschedule?.codename ===
              "add_jobschedule" ? (
            <button
              type="button"
              onClick={() =>
                Navigate(
                  "/dashboard/management/scheduler-dashboard/schedule-job"
                )
              }
              className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
            >
              Schedule Job
            </button>
             ) : null
            }
          </div>
        </div>
      </div>
      {/* <div className="bg-white shadow-xl rounded-md w-full align-middle font-Montserrat"> */}
      <main className="max-w-full  py-4">
        <Basic/>
        <Table columns={columns} data={Data === undefined ? ([]):(Data)} />
        <SchedularStatistics/>
      </main>
      {/* </div> */}
    </>
  );
}
